import { Component, EventEmitter, Input, OnChanges, OnInit,Output, SimpleChanges } from '@angular/core';
import { VhEventMediator, VhQueryAutoWeb } from 'vhautowebdb';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router'; 
import { forkJoin } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { AtwUpdateDbComponent } from 'vhobjects-service';
import { FunctionService  } from 'vhobjects-service';
@Component({
  selector: 'atw-fee-admin-config',
  templateUrl: './fee-admin-config.component.html',
  styleUrls: ['./fee-admin-config.component.scss']
})
export class AtwFeeAdminConfig extends AtwUpdateDbComponent implements OnInit {
  @Input() type_config : string; // xác định trang đang ở page hay preview
  // @Input() id_subproject : any;
  @Input() objectChoosing: any; //nhận data từ ndcDynamicInputs truyền về
  @Input() device: any // xác định trang ở thiết bị desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any;@Input() type: any; // là dữ liệu desktop_config hoặc mobile_config từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database

  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  currentViewAll: any = {};
  isCollapsed: boolean = false;
  styles_field = [
    {
      title: 'hieu_ung_chuyen_dong',
      index: 1,
    }
  ];

  fonts = [];
  effect_hover = [];
  effect_hover_data: any = {};
  dataAfterChange: any  = {};
  id_subproject: any = "";
  link_type: any = [
    {
      name: 'Mở trong trang mới',
      value: '_blank'
    },
    {
      name: 'Mở trong trang hiện tại',
      value: '_self'
    }
  ];
  configMode: 'basic' | 'advanced' = 'basic';
   
  // private textFormatDiffer: KeyValueDiffer<string, any>;
  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    private http: HttpClient,
    private dialog: MatDialog,  
    private route: ActivatedRoute,
    private router: Router,
    public vhEventMediator: VhEventMediator,
    public functionService: FunctionService
  ) {
    super(vhQueryAutoWeb, vhEventMediator, functionService);
  }

  ngOnInit(): void {
    
    // phần này get dữ liệu json
    forkJoin([
      this.http.get('assets/fonts/fonts.json'),
      this.http.get('assets/data/effects/text.json'), 
    ]) .subscribe(([fonts, effects]:any)=>{
      this.fonts = fonts;
      this.effect_hover = effects;
      this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type']);
    })
  }

  ngOnChanges(): void {
    if (this.effect_hover) {
      this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type']);
      this.customize = this.effect_hover_data?.data?.find(e => e.id == this.config['animation-selected']?.id)?.customize || [];
    }
  }

  ngOnDestroy() {
    this.saveDataProperties();
  }

  /**
   * Cập nhật text-shadow
   */
  handleSetTextShadow() {
    this.class['fee__content']['filter'] = `drop-shadow(${this.config['filter']['offset_x']}px ${this.config['filter']['offset_y']}px ${this.config['filter']['blur_radius']}px ${this.config['filter']['shadow_color']})`;
  }

  /** Định dạng hiệu ứng văn bản (phong cách và kiểu cọ)
   * @param action : trả về hiệu ứng văn bản đã chọn
   */
  dispatchStyles(action) {
    // reset những style khác trước
    switch (action) {
      case 'Đổ bóng':
        this.config['text_style'] = 'shadow';
        this.class['fee__content']['-webkit-text-stroke-width'] = "0";
        this.class['fee__wrapper']['background-color'] = "";
        this.class['fee__wrapper']['border-top-left-radius'] = "0%";
        this.class['fee__wrapper']['border-top-right-radius'] = "0%";
        this.class['fee__wrapper']['border-bottom-right-radius'] = "0%";
        this.class['fee__wrapper']['border-bottom-left-radius'] = "0%";
        this.handleSetTextShadow();
        break;

      case 'Tạo stroke':
        this.config['text_style'] = 'stroke';
        this.class['fee__content']['filter'] = "";
        this.class['fee__wrapper']['background-color'] = "";
        this.class['fee__wrapper']['border-top-left-radius'] = "0%";
        this.class['fee__wrapper']['border-top-right-radius'] = "0%";
        this.class['fee__wrapper']['border-bottom-right-radius'] = "0%";
        this.class['fee__wrapper']['border-bottom-left-radius'] = "0%";
        this.class['fee__content']['-webkit-text-stroke-width'] = '2px';
        break;

      case 'background':
        this.config['text_style'] = 'background';
        this.class['fee__content']['-webkit-text-stroke-width'] = "0";
        this.class['fee__content']['filter'] = "";
        this.class['fee__wrapper']['background-color'] = "#008848";
        break;

      default:
        this.config['text_style'] = '';
        this.class['fee__content']['-webkit-text-stroke-width'] = "0";
        this.class['fee__content']['filter'] = "";
        this.class['fee__wrapper']['background-color'] = "";
        this.class['fee__wrapper']['border-top-left-radius'] = "0%";
        this.class['fee__wrapper']['border-top-right-radius'] = "0%";
        this.class['fee__wrapper']['border-bottom-right-radius'] = "0%";
        this.class['fee__wrapper']['border-bottom-left-radius'] = "0%";
    }

    this.updateClass();
  }

  customize = []
  
  // /**
  //  * Hàm update class
  //  */
  // updateClass() {
  //   this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class })
  //     .then((bool: any) => {
        
  //     })
  // }

  // /**
  //  * Hàm update config`
  //  */
  // updateConfig() {
  //   this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_config']: this.config })
  //     .then((bool: any) => {
        
  //     })
  // }

  // /**
  //  * Hàm update object vào database.
  //  */
  // updateObject() {
  //   this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class, [this.device + '_config']: this.config, staticdata: this.staticdata })
  //     .then((bool: any) => {
        
  //     })
  // }

  /**
   * Set style changed
   * @param name : tên trường data cần lưu
   * @param value : giá trị data
   */
  updateCss(name,key){
    this.dataAfterChange[name] = {...key}
  }

  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

  /**
   * Hàm này dùng để cho phép mở menu config .
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại. 
   * @param: value
   */
  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }
  openMap: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false
  };


  /**
   * Cập nhật lưu data vào database.
   */
  saveDataProperties() {
    if (Object.keys(this.dataAfterChange).length)
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, this.dataAfterChange)
    .then((bool) => {
      
    }, error => {
      console.error(error)
    })
  }

  /**
   * Hàm này set customize mở mở phần mở rộng của config từ choose-animations-config truyền về
   * @param event customize sau khi thay đổi
   */
  openAnimationDetail(event) {
    this.customize = event;
    if (this.config['animation-selected'].id != '000000') {
      this.openViewAll(this.styles_field[0]);
    }
  }

  /**
   * update trường mobile_portrait_hidden or desktop_hidden cho object
   * @param value 
   */
  updateHidden(value) {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, value)
    .then((bool) => {
      
    }, error => {
      console.error(error)
    })
  }
}